/**
 * Result Pipeline role actions.
 *
 * IMPORTANT — these are COSMETIC until the backend catches up. Every endpoint this module
 * reads or writes (`SagaState/get-all-*-paged`, all five replay triggers, every
 * `Dead*Result` read and retry) currently carries NO authorization attribute, and neither
 * api.query nor api.command declares a fallback policy. So the server accepts these calls
 * unauthenticated.
 *
 * Consequence for gating: gate DEFAULT-OPEN and never hard-deny on these keys alone. A UI
 * that denies would lock out users the backend permits, which is strictly worse than a UI
 * that permits what the backend already permits. This mirrors the Result Audit and Result
 * Time Machine precedent of borrowing an existing action until a dedicated one is seeded.
 *
 * Mirrors `iElect.ServiceDefaults/Authorization/ActionKeys.cs`. Adding a key here does
 * nothing until it is also added there AND seeded in `api.core/Data/Seeder/Seed.cs`.
 */
export const ACTIONS_RESULT_PIPELINE = {
	RESULT_PIPELINE: 'result_pipeline',
	RESULT_PIPELINE_VIEW: 'result_pipeline_view',
	RESULT_PIPELINE_TRIGGER: 'result_pipeline_trigger',
	RESULT_PIPELINE_DEAD_RETRY: 'result_pipeline_dead_retry',
} as const;
